var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgProject = function SvgProject(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 168.72 168.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M121.69,41.69H99.4a15.94,15.94,0,0,0-30.08,0H47A10.7,10.7,0,0,0,36.36,52.36V127A10.7,10.7,0,0,0,47,137.69h74.66A10.7,10.7,0,0,0,132.36,127V52.36A10.7,10.7,0,0,0,121.69,41.69Zm-37.33,0A5.34,5.34,0,1,1,79,47,5.35,5.35,0,0,1,84.36,41.69ZM69.91,112.57,56.09,98.76a5.32,5.32,0,0,1,7.52-7.52l10.08,10,31.36-31.36a5.32,5.32,0,1,1,7.52,7.52L77.43,112.57A5.31,5.31,0,0,1,69.91,112.57Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/project.cebdc371.svg";
export { ForwardRef as ReactComponent };